export const FILTER_TYPE = {
  NONE: 'none',
  INPUT: 'input_filter',
  DATE: 'date_filter',
  COMBO: 'combo_filter'
};

export const FILTER_SUFFIX = {
  START: 'Start',
  END: 'End',
  IDS: 'Ids'
};
